import { ItemType } from "antd/lib/menu/hooks/useItems";
import { PERMISSIONS } from "authProvider";
import { PermissionEnum } from "enums/permission.enum";

export const checkPermission = (requiredPermissions: PermissionEnum[]): boolean => {
  const permissionsData = localStorage.getItem(PERMISSIONS);
  if (!permissionsData || permissionsData === "null" || permissionsData === "undefined") {
    return false;
  }

  const userPermissions = JSON.parse(permissionsData);
  return requiredPermissions.some((permission) => userPermissions.includes(permission));
};

export const getUserPermissions = (): PermissionEnum[] => {
  const permissionsData = localStorage.getItem(PERMISSIONS);
  if (!permissionsData || permissionsData === "null" || permissionsData === "undefined") {
    return [];
  }
  return JSON.parse(permissionsData);
};

export const withPermission = (requiredPermission: PermissionEnum[]) => (WrappedComponent: any) => {
  const WithPermission = (props: any) => {
    const hasPermission = checkPermission(requiredPermission);
    return hasPermission ? <WrappedComponent {...props} /> : null;
  };

  return WithPermission;
};

export const generateAntdMenuItems = (menuConfig: any[]): ItemType[] => {
  const result: ItemType[] = [];
  
  menuConfig.forEach((item) => {
    if (!item || typeof item !== "object") {
      return;
    }
    
    const hasPermission = !item?.permissions || checkPermission(item?.permissions);

    if (hasPermission) {
      const { permissions = undefined, ...antdItem } = item;

      if (item.children && item.children.length > 0) {
        const childrenItems = generateAntdMenuItems(item.children);
        if (childrenItems && childrenItems.length > 0) {
          antdItem.children = childrenItems;
        } else {
          return;
        }
      }

      result.push(antdItem);
    }
  });

  return result;
};
 
 
 
